import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import CTAButton from '../../../CTAButton/CTAButton';
import Container from '../../../Container/Container';

import DataSummaryUSPA from './DataSummaryUSPA/DataSummaryUSPA';
import {
  TXTCLI_Confirm,
  TXTCLI_Summary,
  TXTWCL_Double_check_your_details,
  TXTWCL_Please_check_that_your_persona_ELL_1
} from './RMFSummaryScreenUSPA.messages.json';

const RMFSummaryScreenUSPA: React.FC = () => {
  const [enableConfirm, setEnableConfirm] = useState(false);

  return (
    <Container
      page={RMFSummaryScreenUSPA}
      headerProps={{
        title: <Translation {...TXTCLI_Summary} />,
        buttons: { back: false }
      }}
      pageTopTitle={<Translation {...TXTWCL_Double_check_your_details} />}
      pageTopSubtitle={<Translation {...TXTWCL_Please_check_that_your_persona_ELL_1} />}
    >
      <DataSummaryUSPA handleCompleteForm={() => setEnableConfirm(true)} />
      <CTAButton translation={TXTCLI_Confirm} disabled={!enableConfirm} />
    </Container>
  );
};

RMFSummaryScreenUSPA.displayName = 'RMFSummaryScreenUSPA';

export default RMFSummaryScreenUSPA;
